<template>
  <div class="user-content-section">
    <div class="page-sub-title user-sub-title">
      <h2>
        <i class="fa-title"></i><i>{{ $t("bonuses") }}</i>
      </h2>
    </div>
    <div class="user-shape-box user-shape-3">
      <div class="user-shape money-shape">
        <div class="user-shape-icons">
          <i class="fa-title shape-icon-bg"></i>
          <i class="fa-money shape-icon"></i>
        </div>
        <div class="user-shape-content" v-if="user">
          <b>{{ user.balance || "0" }}</b>
          <p>{{ $t("bonus") }}</p>
        </div>
      </div>
      <div class="user-shape">
        <div class="user-shape-icons">
          <i class="fa-title shape-icon-bg"></i>
          <i class="fa-trade shape-icon"></i>
        </div>
        <div class="user-shape-content shape-sum" v-if="user.balance">
          <p>
            <b>{{ user.balance }}</b> {{ $t("bonus") }}
          </p>
          <b class="shape-sum-icon">=</b>
          <p>
            <b>{{ user.balance * 1000 }}</b> {{ $t("som") }}
          </p>
        </div>
        <div class="user-shape-content shape-sum" v-else>
          <p><b>1</b> {{ $t("bonus") }}</p>
          <b class="shape-sum-icon">=</b>
          <p><b>1 000</b> {{ $t("som") }}</p>
        </div>
      </div>
      <div class="shape-empty"></div>
      <div class="shape-empty"></div>
      <a href="#" class="trade-btn" @click.prevent="getBonus"
        ><span>{{ $t("withdraw") }}</span
        ><i class="fa-money"></i
      ></a>
    </div>
  </div>
</template>

<script>
export default {
  title: "Bonuslar",
  methods: {
    getBonus() {
      this.$store.dispatch("getMoney");
    },
  },
  computed: {
    user() {
      return this.$store.getters.getUserCredentials;
    },
    lang() {
      return this.$store.getters.lang;
    },
  },
};
</script>
